class WebTokenUtil {
  static getPlatformByWebToken(webToken) {
    if (!webToken) return

    const localSessionType = webToken.split(':').pop() // 웹토큰의 마지막 구분자
    let region

    switch (localSessionType) {
      case 'KPF':
        region = 'krpc'
        break
      case 'JPF':
        region = 'jppc'
        break
      case 'ANA':
        region = 'arena'
        break
      case 'AWT':
        region = 'arena_west'
        break
      case 'ATH':
        region = 'arena_th'
        break
      case 'ATW':
        region = 'arena_tw'
        break
      case 'ASA':
        region = 'arena_sea'
        break
      case 'AJP':
        region = 'arena_jp'
        break
      case 'TOY':
        region = 'toy'
        break
    }

    return region
  }
}

export default WebTokenUtil